function NotFound() {
    return (<div style={{textAlign: 'center', padding: '10.1%'}}>
        <h1>404</h1>
        <p>No books found</p>
    </div>);
}

export default NotFound;